import { IChartVariant } from './../shared.d';
import { TFilterResult } from 'types/shared';

export function filterBySelectedVariant(
  selectedChartVariant?: IChartVariant
): TFilterResult<any> {
  return (chart: any): boolean => {
    return (
      !selectedChartVariant?.id || chart.chartId === selectedChartVariant?.id
    );
  };
}

export function filterBySelectedCustomer(
  selectedCustomer: any
): TFilterResult<any> {
  return (chart: any): boolean => {
    return chart.customerName === selectedCustomer.label;
  };
}

export function isGlobal(territory: any): boolean {
  return territory.countryId === 'WW';
}

export function filterByGlobal(chart: any): boolean {
  return chart.territoryData.some(isGlobal);
}

export function filterByLocal(chart: any): boolean {
  return !chart.territoryData.some(isGlobal);
}

export function filterPositionOver(n: number): any {
  return (chart: any): boolean => chart.currentPosition < n;
}
